export default "__VITE_ASSET__CrJYwDPv__"